import React, { useState } from 'react'
import { buildWhatsAppInquiryMessage, buildWhatsAppInquiryUrl, contactTourOptions } from '../data/companyInfo'

function FaqContact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        tourValue: contactTourOptions[0]?.value || 'select-tour-type',
        message: ''
    });

    const selectedTour = contactTourOptions.find((option) => option.value === formData.tourValue);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (formData.tourValue === 'select-tour-type') {
            window.alert('Please select a tour destination.');
            return;
        }

        const inquiryMessage = buildWhatsAppInquiryMessage({
            intro: 'FAQ Inquiry',
            fields: [
                ['Name', formData.name],
                ['Email', formData.email],
                ['Tour', selectedTour?.label],
                ['Question', formData.message]
            ],
            source: 'FAQ Form'
        });

        window.open(buildWhatsAppInquiryUrl(inquiryMessage), '_blank', 'noopener,noreferrer');
    };

    return (
        <div
            className="bg-top-center space overflow-hidden"
            style={{background: "url(/assets/img/bg/tour_bg_3.jpg)", backgroundRepeat: "no-repeat", position: "relative", zIndex: "1"}}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-11">
                        <div className="">
                            <div className="title-area text-center mb-30">
                                <span className="sub-title style1">Talk to Himolan Team</span>
                                <h2 className="sec-title">Do You Have Any&nbsp;More Questions?</h2>
                            </div>
                            <form
                                className="contact-form ajax-contact"
                                onSubmit={handleSubmit}
                            >
                                <h3 className="sec-title mb-30">Ask About Your Tour</h3>
                                <div className="row">
                                    <div className="col-md-6 form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            id="name3"
                                            placeholder="Your Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                        <img src="/assets/img/icon/user.svg" alt="" />
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            id="email3"
                                            placeholder="Your Mail"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        <img src="/assets/img/icon/mail.svg" alt="" />
                                    </div>
                                    <div className="form-group col-12">
                                        <select
                                            name="tourValue"
                                            id="subject"
                                            className="form-select nice-select"
                                            value={formData.tourValue}
                                            onChange={handleChange}
                                        >
                                            {contactTourOptions.map((option, index) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                    disabled={index === 0}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group col-12">
                                        <textarea
                                            name="message"
                                            id="message"
                                            cols={30}
                                            rows={3}
                                            className="form-control"
                                            placeholder="Write your question"
                                            value={formData.message}
                                            onChange={handleChange}
                                        />
                                        <img src="/assets/img/icon/chat.svg" alt="" />
                                    </div>
                                    <div className="form-btn col-12 mt-24">
                                        <button type="submit" className="th-btn style3">
                                            Send on WhatsApp <img src="/assets/img/icon/plane.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                                <p className="form-messages mb-0 mt-3" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FaqContact
